import { useMemo } from 'react'

import { InFilterDefinition } from '@factorialco/f0-react'
import {
  LegalEntitiesExpenseFilterDocument,
  LegalEntitiesExpenseFilterQuery,
} from 'generated/resources/graphql'

import { useGraphqlDataSource } from 'modules/core/hooks/useGraphqlDataSource'
import i18n from 'modules/core/lib/i18n'

const extractConnection = (data: LegalEntitiesExpenseFilterQuery) =>
  data.companies.legalEntitiesConnection

const extractNodes = (connection: ReturnType<typeof extractConnection>) =>
  connection.edges.map((edge) => edge.node)

type Node = ReturnType<typeof extractNodes>[number]

export const useLegalEntityIdsFilter = (): InFilterDefinition<string> => {
  const source = useGraphqlDataSource(
    {
      paginationType: 'infinite-scroll',
      fetchPolicy: 'cache-first',
      document: LegalEntitiesExpenseFilterDocument,
      perPage: 25,
      mapData: (data) => extractNodes(extractConnection(data)),
      mapPagination: (data) => {
        const connection = extractConnection(data)
        return {
          total: connection.totalCount ?? 0,
          cursor: connection.pageInfo.endCursor ?? undefined,
          hasNextPage: !!connection.pageInfo.hasNextPage,
        }
      },
      mapVariables: ({ search }) => ({ search }),
    },
    []
  )

  return useMemo(
    () => ({
      label: i18n.t('expenses_v2.list.filters.label_legal_entity'),
      type: 'in' as const,
      options: {
        source,
        mapOptions: (entity: Node) => ({
          label: entity.legalName,
          value: entity.id,
        }),
      },
    }),
    [source]
  )
}
